/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const snsPublish = /* GraphQL */ `
  query SnsPublish($id: String!, $email: String!, $username: String!) {
    snsPublish(id: $id, email: $email, username: $username)
  }
`;
export const getRedmineConfig = /* GraphQL */ `
  query GetRedmineConfig($id: ID!) {
    getRedmineConfig(id: $id) {
      id
      name
      redmineurl
      apikey
      taskListStatus {
        progress {
          id
          name
        }
        closed {
          id
          name
        }
      }
      owner
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const listRedmineConfigs = /* GraphQL */ `
  query ListRedmineConfigs(
    $filter: ModelRedmineConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRedmineConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        redmineurl
        apikey
        taskListStatus {
          progress {
            id
            name
          }
          closed {
            id
            name
          }
        }
        owner
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
